import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var MobileIcon = function () {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "#647386", children: _jsx("path", { d: "M12.24 0H3.76C1 0 0 1 0 3.81v12.38C0 19 1 20 3.76 20h8.47C15 20 16 19 16 16.19V3.81C16 1 15 0 12.24 0zM8 17.3a1.75 1.75 0 1 1 1.75-1.75A1.758 1.758 0 0 1 8 17.3zm2-13.05H6a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5z", transform: "translate(4 2)", "data-name": "vuesax/bold/mobile" }) }));
};
export default memo(MobileIcon);
